import styled from 'styled-components';

export const SpringBootWrapper = styled.div`
.text-align-justify{
    text-align: justify;
}
.entry-title {
    font-weight: 600;
    font-size: 1.9rem;
    text-align: center;
}
.text-align-center{
    text-align: center;
}
.text-align-left{
    text-align: left;
}
.accordion-button {
    color: black;
    background-color: #e7faca;
    font-weight: bold;
    font-family: Times New Roman;
    font-size: 20px;
    letter-spacing:0.5px;
    font-style: italic;
}
p, li {
    color: #334155;
}
p, li {
    font-family: -apple-system, BlinkMacSystemFont, Segoe UI, Roboto, Oxygen-Sans, Ubuntu, Cantarell, Helvetica Neue, sans-serif;
    font-weight: 400;
    font-size: 1rem;
    color: #334155;
}
img {
    box-sizing: border-box;
    height: auto;
    max-width: 100%;
    vertical-align: bottom;
}
.accordion-item{
    border: 1px solid #b1ba8e;
}
.accordion-button:focus{
    box-shadow: 0 0 0 .20rem #b1ba8e;
}
a {
    color: #647f19;
}
`;
